// Textos da interface em português. Tudo o que o jogador lê passa por aqui,
// então trocar de tema ou de idioma não exige mexer no motor nem nos componentes.

export const strings = {
  appTitle: 'Estandarte',
  appSubtitle: 'guerra de guildas',
  tagline: 'Estratégia por turnos num atlas de campanha',
  disclaimer:
    'Projeto de fã sem fins lucrativos, sem afiliação com a CipSoft GmbH. Tibia e os nomes citados são propriedade da CipSoft GmbH.',
  troops: 'tropas',
  phases: {
    setup: 'Posicionamento',
    boss: 'Fase de boss',
    reinforce: 'Reforços',
    attack: 'Ataque',
    fortify: 'Remanejar',
    over: 'Fim de jogo',
  } as Record<string, string>,
  nextPhase: {
    reinforce: 'Ir para o ataque',
    attack: 'Ir para remanejar',
    fortify: 'Encerrar turno',
  } as Record<string, string>,
  symbols: { sword: 'Espada', shield: 'Escudo', staff: 'Cajado', wild: 'Curinga' } as Record<string, string>,
  symbolGlyph: { sword: '⚔', shield: '⛨', staff: '⚚', wild: '✦' } as Record<string, string>,
  addons: {
    sea: { name: 'Rotas de barco', text: 'Ataques por barco rolam no máximo 2 dados.' },
    vocations: { name: 'Vocações', text: 'Cada guilda tem um poder que vale a partida inteira.' },
    bosses: { name: 'Bosses', text: 'Bosses surgem nos covis, fazem raids e deixam loot para o último golpe.' },
  },
  fallbackMission: (n: number) => `Conquistar ${n} territórios.`,
  errors: {
    game_over: 'A partida já terminou.',
    not_your_turn: 'Não é a sua vez.',
    pending_action: 'Resolva a escolha pendente primeiro.',
    nothing_pending: 'Não há nada para resolver agora.',
    wrong_phase: 'Essa ação não vale nesta fase.',
    not_owner: 'Esse território não é seu.',
    not_adjacent: 'Os territórios não são vizinhos.',
    bad_count: 'Quantidade de tropas inválida.',
    bad_choice: 'Escolha inválida.',
    bad_action: 'Ação inválida.',
    bad_player: 'Jogador inválido.',
    must_trade: 'Com 5 ou mais cartas, a troca é obrigatória.',
    invalid_set: 'Troque 3 cartas iguais ou 3 diferentes.',
    no_reinforcements: 'Você não tem reforços para posicionar.',
    reinforcements_left: 'Posicione todos os reforços antes.',
    cannot_attack: 'Ataque inválido.',
    power_unavailable: 'O poder não pode ser usado agora.',
    no_loot: 'Você não tem essa carta.',
    loot_not_now: 'Essa carta não pode ser jogada agora.',
    frozen: 'Território congelado não recebe tropas.',
    blocked: 'Movimento bloqueado (Magic Wall, congelado ou paralisado).',
    bad_target: 'Alvo inválido para essa carta.',
    pending_reaction: 'Aguarde a decisão do Amuleto da Sorte.',
    truce: 'Trégua: ainda não dá para atacar outra guilda.',
  } as Record<string, string>,
  serverErrors: {
    room_not_found: 'Sala não encontrada.',
    wrong_password: 'Senha errada.',
    room_full: 'A sala está cheia.',
    game_started: 'A partida já começou.',
    name_taken: 'Esse nome já está em uso na sala.',
    rate_limited: 'Muitas tentativas. Espere um minuto.',
    not_host: 'Só o anfitrião pode fazer isso.',
    color_taken: 'Essa guilda já foi escolhida.',
    invalid_message: 'Mensagem inválida.',
    not_enough_players: 'São precisos pelo menos 3 lugares preenchidos.',
    too_many_bots: 'No máximo 5 bots.',
    bad_token: 'Sessão expirada. Entre de novo.',
    not_in_room: 'Você não está numa sala.',
    kicked: 'Você foi removido da sala pelo anfitrião.',
    connection: 'Sem conexão com o servidor.',
  } as Record<string, string>,
  scoreReasons: {
    mission: 'Missão cumprida',
    lastStanding: 'Último sobrevivente',
    serverSave: 'Server Save',
  } as Record<string, string>,
};

export type Strings = typeof strings;
